import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'Loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit {

  @Input() loading: boolean = false;

  @Input() titulo: string = 'Processando...';

  @Input() subtitulo: string ='Aguarde, isso pode levar alguns instantes.';

  constructor() { }

  ngOnInit(): void {
  }

}
